import React from 'react';
import { Section, Container, Typography, Anchor, Button, Card } from 'components/base';

import { Head } from '../components/layout';

const MaintenancePage = () => {
  return (
    <>
      <Head title="Maintenance" noindex />

      <Section>
        <Container className="text-center">
          <Anchor href="/" className="logo">
            <img
              src="/static/img/icon-logo.png"
              srcSet="/static/img/icon-logo@2x.png 2x"
              alt="Parabo PRESS"
            />
          </Anchor>
        </Container>
      </Section>

      <Section type="orange">
        <Container className="text-center p-5">
          <Typography.H2 className="section-title mb-2">
            Sorry! Our site is temporarily down for some scheduled maintenance
          </Typography.H2>
          <Typography.H4>
            We should be up and running in just a bit.
            <br />
            Come on back or refresh this page to see when we’re back (and better than ever).
          </Typography.H4>
          <Button type="primary" className="mt-5" onClick={() => window.location.reload()}>
            Refresh Now
          </Button>
        </Container>
      </Section>

      <Section className="text-center">
        <Container className="p-5">
          <Typography.H4 className="mb-2">
            Have an urgent question? You can still reach us via email, or browse our help center.
          </Typography.H4>
          <Typography.P className="mb-0">
            <a href="mailto:help@parabo.press" className="text-link">
              help@parabo.press
            </a>{' '}
            &nbsp;{' '}
            <a
              href="https://knowledge-base--parabo.groovehq.com/help"
              target="_blank"
              rel="noreferrer"
              className="text-link"
            >
              Check out our FAQ
            </a>
          </Typography.P>
        </Container>
      </Section>
    </>
  );
};

export default MaintenancePage;
